/**
 * 한국 주요 은행 목록
 */
export const BANK_LIST = [
  { code: 'KB', name: '국민은행' },
  { code: 'SHINHAN', name: '신한은행' },
  { code: 'WOORI', name: '우리은행' },
  { code: 'HANA', name: '하나은행' },
  { code: 'NH', name: 'NH농협은행' },
  { code: 'IBK', name: 'IBK기업은행' },
  { code: 'SC', name: 'SC제일은행' },
  { code: 'CITI', name: '한국씨티은행' },
  { code: 'KAKAO', name: '카카오뱅크' },
  { code: 'TOSS', name: '토스뱅크' },
  { code: 'KBANK', name: '케이뱅크' },
  { code: 'DGB', name: 'DGB대구은행' },
  { code: 'BNK_BUSAN', name: 'BNK부산은행' },
  { code: 'BNK_KYONGNAM', name: 'BNK경남은행' },
  { code: 'GWANGJU', name: '광주은행' },
  { code: 'JEONBUK', name: '전북은행' },
  { code: 'JEJU', name: '제주은행' },
  { code: 'SUHYUP', name: '수협은행' },
  { code: 'SAEMAUL', name: '새마을금고' },
  { code: 'SHINHYUP', name: '신협' },
  { code: 'POST', name: '우체국' },
] as const;

export type BankCode = (typeof BANK_LIST)[number]['code'];
export type BankName = (typeof BANK_LIST)[number]['name'];
